import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import axiosConfig from '../../src/Service/axiosConfig';
import Select from 'react-select';
import AlertDeletePopupModal from '../Components/PopupModal/AlertDeletePopupModal';
import { PopupModal } from '../Components';

function ProfessionalProofs() {
    let { id } = useParams();
    const [loading, setLoading] = useState(false);
    const [Data, SetData] = useState([]);
    const [roles, setRoles] = useState([]);
    
    const [desigdata, setdesigdata] = useState({});
    const [editId, setEditId] = useState(null);
    const [editData, setEditData] = useState({});

    const [popupType, setpopupType] = useState("");
    const [alertDeletePopupType, setAlertDeletePopupType] = useState("");
    const [deleteRowId, setDeleteRowId] = useState(null);

    const GetData = () => {
        setLoading(true);
        axiosConfig.get(`/accounts/verified-profile-designations/?verified_profile=${id}`)
            .then(res => {
                SetData(res.data.results);
                setLoading(false);
            })
            .catch(error => {
                console.log(error);
                setLoading(false);
            });
    };

    const getRoles = async () => {
        try {
            const responce = await axiosConfig.get(`/masters/role-24-frames/?page_size=1000`)
            setRoles(responce.data.results)
        }
        catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        GetData();
        getRoles();
    }, []);

    const handleAddChange = (e) => {
        const { name, value } = e.target;
        setdesigdata({ ...desigdata, [name]: value });
    };

    const handleAddSelectChange = (selectedOption, name) => {
        setdesigdata({ ...desigdata, [name]: selectedOption?.value || "" });
    };

    const handleAddFileChange = (e) => {
        const name = e.target.name;
        const file = e.target.files[0];
        setdesigdata({ ...desigdata, [name]: file });
    };

    const handleEditClick = (item) => {
        setEditId(item.id);
        setEditData({
            id: item.id,
            role: item.role?.id || item.role,
            designation_union_name: item.designation_union_name,
            designation_union_copy: null 
        });
    };

    const handleCancelEdit = () => {
        setEditId(null);
        setEditData({});
    };

    const handleEditChange = (e) => {
        const { name, value } = e.target;
        setEditData({ ...editData, [name]: value });
    };

    const handleEditSelectChange = (selectedOption, name) => {
        setEditData({ ...editData, [name]: selectedOption?.value || "" });
    };

    const handleEditFileChange = (e) => {
        const name = e.target.name;
        const file = e.target.files[0];
        setEditData({ ...editData, [name]: file });
    };

    const submitData = (dataToSubmit, isEdit = false) => {
        const formData = new FormData();
        formData.append('verified_profile', id);
        
        if (dataToSubmit.role) formData.append('role', dataToSubmit.role);
        if (dataToSubmit.designation_union_name) formData.append('designation_union_name', dataToSubmit.designation_union_name);
        
        if (dataToSubmit.designation_union_copy instanceof File) {
            formData.append('designation_union_copy', dataToSubmit.designation_union_copy);
        }

        if (isEdit && dataToSubmit.id) {
            axiosConfig.patch(`/accounts/verified-profile-designations/${dataToSubmit.id}/`, formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            })
            .then(res => {
                GetData();
                handleCancelEdit();
                setpopupType("success");
            })
            .catch(error => {
                console.log(error.response);
                setpopupType("error");
            });
        } else {
            axiosConfig.post("/accounts/verified-profile-designations/", formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            })
            .then(res => {
                GetData();
                setdesigdata({});
                setpopupType("success");
            })
            .catch(error => {
                console.log(error.response);
                setpopupType("error");
            });
        }
    };

    const initiateDelete = (itemId) => {
        setDeleteRowId(itemId);
        setAlertDeletePopupType("success");
    }

    const confirmDelete = (itemId) => {
        axiosConfig.delete(`/accounts/verified-profile-designations/${itemId}/`)
            .then(() => {
                GetData();
                setAlertDeletePopupType("error");
                setpopupType("success");
            })
            .catch(err => {
                console.log(err);
                setAlertDeletePopupType("error");
                setpopupType("error");
            });
    }

    const cancelDeleteAlert = () => {
        setAlertDeletePopupType("error");
        setDeleteRowId(null);
    }

    if (loading) {
        return <div>Loading...</div>;
    }

    return (
        <div style={styles.container}>
            <div style={styles.cardContainer}>
                {Data.length === 0 ? (
                    <p>No data available</p>
                ) : (
                    Data.map((item) => (
                        <div key={item.id} style={styles.card}>
                            <h2 style={styles.headingLeft}>{item.designation_union_name}</h2>
                            {item.designation_union_copy && (
                                <img src={item.designation_union_copy} alt={item.designation_union_name} style={styles.image} />
                            )}
                            <p style={styles.role}>Frame Name: {item.role?.frame_name || 'N/A'}</p>
                        </div>
                    ))
                )}
            </div>

            <div className="customtable-responsive" style={{ width: '100%', marginTop: '20px' }}>
                <table className="table table-bordered">
                    <thead>
                        <tr>
                            <th>Sr</th>
                            <th>Designation Name</th>
                            <th>Designation Union Name</th>
                            <th>Designation Union Proof</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {Data.map((frame, index) => {
                            const isEditing = editId === frame.id;
                            return (
                                <tr key={frame.id}>
                                    <td>{index + 1}</td>
                                    <td>
                                        {isEditing ? (
                                            <Select
                                                options={roles.map((res) => ({ value: res.id, label: res.frame_name }))}
                                                placeholder="Select Designation"
                                                value={roles.map(res => ({ value: res.id, label: res.frame_name })).find(res => res.value === editData.role)}
                                                onChange={(opt) => handleEditSelectChange(opt, "role")}
                                            />
                                        ) : (
                                            frame.role?.frame_name || 'N/A'
                                        )}
                                    </td>
                                    <td>
                                        {isEditing ? (
                                            <input 
                                                type="text" 
                                                className="form-control" 
                                                name="designation_union_name" 
                                                value={editData.designation_union_name || ""}
                                                onChange={handleEditChange} 
                                            />
                                        ) : (
                                            frame.designation_union_name || ' '
                                        )}
                                    </td>
                                    <td>
                                        {isEditing ? (
                                            <input 
                                                type="file" 
                                                className="form-control" 
                                                name="designation_union_copy" 
                                                onChange={handleEditFileChange} 
                                            />
                                        ) : (
                                            frame.designation_union_copy ? (
                                                <img src={frame.designation_union_copy} alt="Proof" style={{ width: '50px', height: '50px', objectFit: 'cover' }} />
                                            ) : "No Image"
                                        )}
                                    </td>
                                    <td>
                                        {isEditing ? (
                                            <div style={{ display: 'flex', gap: '5px' }}>
                                                <button className="btn btn-success btn-sm" onClick={() => submitData(editData, true)}>Save</button>
                                                <button className="btn btn-secondary btn-sm" onClick={handleCancelEdit}>Cancel</button>
                                            </div>
                                        ) : (
                                            <div style={{ display: 'flex', gap: '5px' }}>
                                                <button className="btn btn-primary btn-sm" onClick={() => handleEditClick(frame)}>Edit</button>
                                                <button className="btn btn-danger btn-sm" onClick={() => initiateDelete(frame.id)}>Delete</button>
                                            </div>
                                        )}
                                    </td>
                                </tr>
                            );
                        })}
                        
                        <tr style={{ backgroundColor: '#f9f9f9' }}>
                            <td>New</td>
                            <td>
                                <Select
                                    options={roles.map((res) => ({ value: res.id, label: res.frame_name }))}
                                    placeholder="Select Designation"
                                    value={roles.map(res => ({ value: res.id, label: res.frame_name })).find(res => res.value === desigdata.role) || null}
                                    onChange={(opt) => handleAddSelectChange(opt, "role")}
                                />
                            </td>
                            <td>
                                <input 
                                    type="text" 
                                    className="form-control" 
                                    placeholder="Designation Union Name" 
                                    name="designation_union_name" 
                                    value={desigdata.designation_union_name || ""}
                                    onChange={handleAddChange} 
                                />
                            </td>
                            <td>
                                <input 
                                    type="file" 
                                    className="form-control" 
                                    name="designation_union_copy" 
                                    onChange={handleAddFileChange} 
                                />
                            </td>
                            <td>
                                <button 
                                    className="btn btn-primary btn-sm" 
                                    onClick={() => submitData(desigdata, false)}
                                >
                                    + Add
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            
            <AlertDeletePopupModal
                AlertDeletePopupType={alertDeletePopupType}
                HandleDelete={confirmDelete}
                CancelAlerrt={cancelDeleteAlert}
                row={deleteRowId}
            />
            
            {popupType !==""&&<PopupModal 
                popupType={popupType} 
                setpopupType={setpopupType} 
            />}
        </div>
    );
}

const styles = {
    container: {
        padding: '20px',
    },
    cardContainer: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    card: {
        border: '1px solid #ddd',
        borderRadius: '8px',
        padding: '20px',
        width: '250px',
        margin: '10px',
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
        textAlign: 'center',
    },
    image: {
        width: '100%',
        height: '150px',
        objectFit: 'cover',
        borderRadius: '8px',
    },
    headingLeft: {
        fontSize: '18px',
        margin: '10px 0',
        textAlign: 'left',
    },
    role: {
        fontSize: '1rem',
        color: '#555',
    },
};

export default ProfessionalProofs;